"use strict";

import angular from "angular";

import template from "./files-imported-list.component.html";
import "./themes/files-imported-list.component.scss";

import _ from "lodash";

import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";
import * as DateUtils from "../../../utils/date/date";
class FilesImportedListComponent {
    constructor($stateParams, $mdDialog, DSNDialogService) {
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;

        this.viewAvailable = {};
        this.monthsSelected = [];
    }

    $onInit() {
        this.months = DateUtils.months();
        this.sourceHuman = SourceConvert.toHumanRead(this.viewConfigs.source);

        this._setViewAvailable();
    }

    $onChanges(changes) {
        if (changes.available) {
            this._setViewAvailable();
        }
    }

    /**
     * Monta a lista de availables
     */
    _setViewAvailable() {
        this.viewAvailable = [];
        this.available.forEach((date) => {
            const _date = DateUtils.getDate(date);
            const year = _date.getFullYear();
            const month = _date.getMonth();

            _.set(this.viewAvailable, `${year}.${month}`, true);
        });
    }

    /**
     * Confere se o mês esta na lista de selecionadoss
     * @param {Number} month
     * @returns
     */
    isChecked(month) {
        const regularMonth = month + 1;

        return this.monthsSelected.includes(
            `${this.currentYear}-${regularMonth}`
        );
    }

    /**
     * Adicionar ou remove o mês da lista de selecionados
     * @param {Number} month
     */
    onSelectMonth(month) {
        const regularMonth = month + 1;

        if (this.isChecked(month))
            _.remove(
                this.monthsSelected,
                (m) => m === `${this.currentYear}-${regularMonth}`
            );
        else this.monthsSelected.push(`${this.currentYear}-${regularMonth}`);
    }

    _confirmRemove({ ev, many, year, month } = {}) {
        const description = many
            ? "Os mêses selecionados serão permanentemente excluídos."
            : "O mês selecionado será permanentemente excluído.";

        const label = "cancelar";

        this.DSNDialogService.confirmation({
            targetEvent: ev,
            locals: {
                title: "Tem certeza que deseja excluir?",
                destructive: true,
                description,
                actions: {
                    cancel: {
                        label,
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    },
                    confirm: {
                        label: "Excluir",
                        action: () => {
                            if (many) {
                                const months = this.monthsSelected;

                                const newAvailable = this._removeFromView(
                                    this.monthsSelected,
                                    true
                                );

                                this.onRemoveMany({
                                    months,
                                    newAvailable
                                });
                            } else {
                                const newAvailable = this._removeFromView([
                                    { year, month }
                                ]);

                                this.onRemove({ year, month, newAvailable });
                            }

                            this.$mdDialog.hide();
                        }
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }

    setImportType(type) {
        this.onSetImportType({ type });
    }
    onClickDownload(year, month) {
        this.onDownload({ year, month });
    }

    onClickRead(year, month) {
        this.onRead({ year, month });
    }

    onClickRemove(year, month, ev) {
        this._confirmRemove({ ev, many: false, year, month });
    }

    onClickRemoveMany(ev) {
        this._confirmRemove({ ev, many: true });
    }

    _removeFromView(dates, many) {
        const available = angular.copy(this.available);

        const datesToRemove = [];

        dates.forEach((d) => {
            let dateToRemove;

            if (many) {
                const dateSplitted = d.split("-");

                this.viewAvailable[dateSplitted[0]][
                    Number(dateSplitted[1]) - 1
                ] = false;

                this.monthsSelected = [];

                const month = String(dateSplitted[1]).padStart(2, 0);

                dateToRemove = new Date(`${dateSplitted[0]}-${month}-01`);
            } else {
                this.viewAvailable[d.year][d.month - 1] = false;

                const month = String(d.month).padStart(2, 0);

                dateToRemove = new Date(`${d.year}-${month}-01`);
            }

            datesToRemove.push(dateToRemove.toISOString());
        });

        _.remove(available, (d) => datesToRemove.includes(d));

        return available;
    }

    onClickDownloadFile(year, month, ev = {}) {
        this.onDownloadFile({
            year,
            month,
            ev
        });
    }

    onDownloadCheck(year) {
        this.downloadCheck({ year: this.currentYear });
    }
}

FilesImportedListComponent.$inject = [
    "$stateParams",
    "$mdDialog",
    "DSNDialogService"
];

const name = "filesImportedListComponent";
const def = {
    bindings: {
        viewConfigs: "<",
        currentYear: "=",
        available: "<",
        onDownload: "&",
        onRemove: "&",
        onRead: "&",
        onRemoveMany: "&",
        onChangeYear: "&",
        loading: "=",
        hasPermissionCompanyModel: "<",
        onSetImportType: "&",
        onDownloadFile: "&",
        downloadAvailable: "<",
        downloadCheck: "&"
    },
    controller: FilesImportedListComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
